import { useIntl } from 'react-intl';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import Image from 'next/image';
import type { ClassAttributes, HTMLAttributes } from 'react';
import { legalHintsImageMessages } from './messages';

export type LegalHintsImageProps = ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>;

export const LegalHintsImage = (props: LegalHintsImageProps) => {
  const { formatMessage } = useIntl();
  const {
    installmentCalculator: { legalHintsImage },
  } = useConfig();

  if (legalHintsImage === null) {
    return null;
  }

  return (
    <div {...props} className="border border-[#000]">
      <Image
        src={legalHintsImage.src}
        width={legalHintsImage.width}
        height={legalHintsImage.height}
        alt={formatMessage(legalHintsImageMessages.alt)}
        unoptimized
      />
    </div>
  );
};
